export default function (state, value) {
    let item = state.items.filter(i => {
        return i.value === value;
    })[0];
    state.items.splice(state.items.indexOf(item), 1);
}